var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinRafiki({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.485,
    height: 159,
    viewBox: "0 0 179.485 159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bitcoin-rafiki",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-6",
    transform: "translate(6.44 133.183)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-6",
    cx: 86.522,
    cy: 5.051,
    rx: 86.522,
    ry: 5.051,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bitcoin--inject-6",
    transform: "translate(0 17.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M210.4,191.56H200.55V291.822H210.4a50.131,50.131,0,0,0,0-100.262Z",
    transform: "translate(-129.654 -170.795)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    "data-name": "Path 4042",
    d: "M210.4,191.56H200.55V291.822H210.4a50.131,50.131,0,0,0,0-100.262Z",
    transform: "translate(-129.654 -170.795)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    "data-name": "Path 4043",
    d: "M149.271,195.573l-.2-.4a51.319,51.319,0,0,1,10.942-3.976l.1.446A51.028,51.028,0,0,0,149.271,195.573Z",
    transform: "translate(-101.147 -170.595)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4044",
    "data-name": "Path 4044",
    d: "M136.235,205.843l-.245-.37c.959-.643,1.95-1.267,2.945-1.843l.223.384C138.172,204.589,137.19,205.205,136.235,205.843Z",
    transform: "translate(-93.904 -177.478)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 50.131,
    cy: 50.131,
    r: 50.131,
    transform: "translate(0 70.896) rotate(-45)",
    fill: "#033096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4045",
    "data-name": "Path 4045",
    d: "M180.5,226.2a40.831,40.831,0,0,0-57.655,57.623A40.831,40.831,0,1,1,180.5,226.2Z",
    transform: "translate(-79.011 -182.357)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Toman",
    transform: "translate(35.548 79.166)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.75,
    fontSize: 22,
    fontFamily: "Vazir-Bold, Vazir",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Toman"))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6",
    transform: "translate(104.564 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 4.369,
    cy: 4.302,
    rx: 4.369,
    ry: 4.302,
    transform: "translate(9.943 7.664)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M310.714,138.4a2.414,2.414,0,1,1-.718-1.7A2.432,2.432,0,0,1,310.714,138.4Z",
    transform: "translate(-292.529 -122.821)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 4.369,
    cy: 4.302,
    rx: 4.369,
    ry: 4.302,
    transform: "translate(15.949 6.865)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4049",
    "data-name": "Path 4049",
    d: "M322.97,397.633l3.583-.053,1.031-8.309-3.583.054Z",
    transform: "translate(-302.009 -263.07)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4050",
    "data-name": "Path 4050",
    d: "M368.633,395.724l3.24-1.892-2.6-7.662-3.235,1.892Z",
    transform: "translate(-325.86 -261.354)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4051",
    "data-name": "Path 4051",
    d: "M374.981,401.537l-3.8,2.155a.3.3,0,0,0-.143.361l.955,3.124a.527.527,0,0,0,.768.295c1.209-.714,2.062-1.29,3.6-2.164.946-.536,3.86-2.057,5.167-2.8s.745-2.129.143-1.946c-2.7.839-4.909,1.142-6.078.892A.893.893,0,0,0,374.981,401.537Z",
    transform: "translate(-328.621 -269.313)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4052",
    "data-name": "Path 4052",
    d: "M325.1,407l-3.914.062a.308.308,0,0,0-.3.245l-.656,3.2a.518.518,0,0,0,.522.629c1.41-.045,3.449-.161,5.221-.187,2.075-.031,3.869.054,6.3,0,1.468-.022,1.852-1.513,1.236-1.638-2.811-.571-5.1-.6-7.546-2.057a1.668,1.668,0,0,0-.866-.25Z",
    transform: "translate(-300.488 -272.889)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4053",
    "data-name": "Path 4053",
    d: "M337.231,163.85c.5,1.049,1.04,2.182,1.589,3.258s1.111,2.178,1.691,3.24a54.812,54.812,0,0,0,3.74,6.064l.254.353c.04.054.04.058.036.067a1.191,1.191,0,0,0-.352-.1c-.2-.022-.339.045-.321.062a.62.62,0,0,0,.263-.112,5.593,5.593,0,0,0,1.008-.893,14.787,14.787,0,0,0,1.053-1.281c.7-.919,1.339-1.937,1.995-2.972s1.263-2.115,1.856-3.164l2.508.977a34.911,34.911,0,0,1-2.878,7.372,19.468,19.468,0,0,1-1.125,1.785,9.346,9.346,0,0,1-1.633,1.785,5.426,5.426,0,0,1-1.366.834,4.1,4.1,0,0,1-2.173.286,4.2,4.2,0,0,1-2.021-.937,6.212,6.212,0,0,1-.62-.607l-.33-.393a34.08,34.08,0,0,1-2.459-3.2c-.763-1.084-1.45-2.2-2.12-3.32s-1.29-2.262-1.883-3.418-1.151-2.3-1.682-3.57Z",
    transform: "translate(-307.154 -138.243)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4054",
    "data-name": "Path 4054",
    d: "M328.884,160.319c-.964,3.284,5.837,12.24,5.837,12.24l6.854-4.409a43.65,43.65,0,0,0-4.752-8.032C333.993,156.517,329.924,156.714,328.884,160.319Z",
    transform: "translate(-305.232 -134.734)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4055",
    "data-name": "Path 4055",
    d: "M334.931,172.356c1.41.6,3.485,4.016,4.565,6.515l-2.923,1.87a54.8,54.8,0,0,1-4.373-6.854C333.133,172.878,334.186,172.039,334.931,172.356Z",
    transform: "translate(-307.121 -142.915)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4056",
    "data-name": "Path 4056",
    d: "M371.083,172.04,370.19,168l4.074-.031s1.089,3.034-1.1,4.462Z",
    transform: "translate(-328.158 -140.524)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    "data-name": "Path 4057",
    d: "M370.684,159.56l3.266,1.174.344,2.579-4.074.031Z",
    transform: "translate(-328.174 -135.867)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4058",
    "data-name": "Path 4058",
    d: "M328.2,389.27l-.531,4.284-3.588.058.535-4.284Z",
    transform: "translate(-302.624 -263.07)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4059",
    "data-name": "Path 4059",
    d: "M366.04,388.068l3.24-1.888,1.334,3.949-3.24,1.888Z",
    transform: "translate(-325.86 -261.359)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4060",
    "data-name": "Path 4060",
    d: "M293.17,158.2c3.86,13.606,3.084,28.046,3.432,30.969,2.8-.2,13.352-.991,19.1-1.419,1.834-20.469-2.508-30.862-2.508-30.862s-1.227-.237-2.9-.411c-.522-.054-1.089-.1-1.678-.129-.326,0-.656-.031-.991-.036a71.513,71.513,0,0,0-8.122.6c-.509.062-1.026.143-1.531.223s-.919.165-1.339.25C294.678,157.774,293.17,158.2,293.17,158.2Z",
    transform: "translate(-285.508 -134.068)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4061",
    "data-name": "Path 4061",
    d: "M315.136,181.7l-3.012,1.473-3.284-1.218-.54-5.288,6.3-.254Z",
    transform: "translate(-293.886 -145.198)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4062",
    "data-name": "Path 4062",
    d: "M299.591,173.62c.344,1.316-.049,7.323-1.424,8.8-.187-1.923-.446-3.931-.768-5.984Z",
    transform: "translate(-287.85 -143.653)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    "data-name": "Path 4063",
    d: "M307.495,137c.71,2.575,1.575,7.327-.125,9.206a9.131,9.131,0,0,0,6.618,2.677c3.115-.12,2.41-2.231,1.5-3.28-2.963-.482-3.052-2.651-2.677-4.717Z",
    transform: "translate(-293.371 -123.374)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4064",
    "data-name": "Path 4064",
    d: "M304.284,156.3s.812,1.923,7.305,3.217a5.708,5.708,0,0,0-1.566,2.722s-8.479-1.424-8.22-5.2A10.163,10.163,0,0,1,304.284,156.3Z",
    transform: "translate(-290.285 -134.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4065",
    "data-name": "Path 4065",
    d: "M326.539,161.236a8.836,8.836,0,0,0-2.789-2.013,3.164,3.164,0,0,0,.669-3.432,13.247,13.247,0,0,1,1.95.08A3.449,3.449,0,0,1,326.539,161.236Z",
    transform: "translate(-302.441 -133.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4066",
    "data-name": "Path 4066",
    d: "M324.433,168.639c.058.393.277.683.491.652s.335-.375.277-.768-.277-.687-.486-.656S324.375,168.242,324.433,168.639Z",
    transform: "translate(-302.812 -140.466)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4067",
    "data-name": "Path 4067",
    d: "M312.437,140.59l3.124,2.3a8.165,8.165,0,0,0-.143,1.459,3.61,3.61,0,0,1-2.95-2.343A3.883,3.883,0,0,1,312.437,140.59Z",
    transform: "translate(-296.149 -125.362)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 4.971,
    cy: 4.895,
    rx: 4.971,
    ry: 4.895,
    transform: "translate(12.772 0.635)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4068",
    "data-name": "Path 4068",
    d: "M321.8,112.626h0a.058.058,0,0,1-.036-.071,4.788,4.788,0,0,0-.469-3.682,4.936,4.936,0,0,0-2.967-2.3.055.055,0,1,1,.027-.107,5,5,0,0,1,3.035,2.347,4.909,4.909,0,0,1,.482,3.771A.062.062,0,0,1,321.8,112.626Z",
    transform: "translate(-299.416 -106.466)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 3.757,
    cy: 3.699,
    rx: 3.757,
    ry: 3.699,
    transform: "translate(18.078 4.036)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 4.369,
    cy: 4.302,
    rx: 4.369,
    ry: 4.302,
    transform: "translate(8.849 3.585)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4069",
    "data-name": "Path 4069",
    d: "M306.234,121.369c.482,3.521.585,5.609,2.5,7.292a4.724,4.724,0,0,0,7.72-3.008c.527-3.235-.348-8.452-3.918-9.6a4.846,4.846,0,0,0-6.305,5.319Z",
    transform: "translate(-292.712 -111.639)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4070",
    "data-name": "Path 4070",
    d: "M301.8,116.941c.366,4.953,11.308-1.977,8.978-4.619s-5.9-.776-7.193.415A4.944,4.944,0,0,0,301.8,116.941Z",
    transform: "translate(-290.279 -108.965)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    "data-name": "Path 4071",
    d: "M319.518,114.362c2.017-.616,5.462,2.981,2.374,2.619S317.152,115.089,319.518,114.362Z",
    transform: "translate(-299.476 -110.799)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    d: "M302.941,134.208a3.369,3.369,0,0,0,2.209,1.339c1.174.17,1.607-.919,1.151-1.946-.406-.924-1.513-2.124-2.628-1.821A1.5,1.5,0,0,0,302.941,134.208Z",
    transform: "translate(-290.727 -120.458)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    d: "M324.285,302.745l-6.064.094s3.5-23.959,2.959-35.106c-.165-3.391.375-8.135-.518-13.218-1.133-6.408-1.678-8.961-3.124-17.055-1.044-5.774-1.968-9.733-1.968-9.733l12.557-.937s4.1,28.876,3.98,39.8C331.965,277.947,324.285,302.745,324.285,302.745Z",
    transform: "translate(-297.912 -173.096)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    d: "M303.237,125.261c2.026.585,2.954,5.48.558,3.49S300.863,124.579,303.237,125.261Z",
    transform: "translate(-290.233 -116.803)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    d: "M327,288.89a42.959,42.959,0,0,1,.527,8.032c1.044,2.95,1.955,5.743,2.588,8.229,1.111,4.351,2.869,10.946,4.583,17.288,1.861-7.426,3.673-16.007,3.731-21.478Z",
    transform: "translate(-304.241 -207.484)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4076",
    "data-name": "Path 4076",
    d: "M313.19,227.89s9.023,22.8,12.441,32.723c3.748,10.866,9.795,40.2,9.795,40.2l-5.7,3.24s-8.894-24.182-12.575-34.767c-4.195-12.049-15.748-31.108-16.288-40.474Z",
    transform: "translate(-289.766 -173.705)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4077",
    "data-name": "Path 4077",
    d: "M370.258,387.5l-6.72,3.811-1.138-2.008,7.439-4.387Z",
    transform: "translate(-323.844 -260.662)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4078",
    "data-name": "Path 4078",
    d: "M327.8,394.192l-7.225.112-.036-2.334,8.073-.25Z",
    transform: "translate(-300.664 -264.427)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4079",
    "data-name": "Path 4079",
    d: "M316.867,128.914c.022.29.192.513.379.5s.321-.259.3-.544-.192-.509-.379-.5S316.845,128.65,316.867,128.914Z",
    transform: "translate(-298.629 -118.595)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4080",
    "data-name": "Path 4080",
    d: "M325.787,128.368c0,.29.192.509.379.5s.326-.259.3-.544-.192-.513-.379-.5S325.765,128.078,325.787,128.368Z",
    transform: "translate(-303.568 -118.29)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    d: "M323.49,129.54a10.4,10.4,0,0,0,1.562,2.365,1.656,1.656,0,0,1-1.339.357Z",
    transform: "translate(-302.297 -119.243)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4082",
    "data-name": "Path 4082",
    d: "M319.217,136.374a2.356,2.356,0,0,1-1.7-.821.085.085,0,1,1,.134-.1,2.294,2.294,0,0,0,1.928.754.08.08,0,0,1,.089.076.085.085,0,0,1-.076.094A2.676,2.676,0,0,1,319.217,136.374Z",
    transform: "translate(-298.979 -122.494)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4083",
    "data-name": "Path 4083",
    d: "M315.315,126.082a.143.143,0,0,1-.08-.027.165.165,0,0,1-.049-.232,1.682,1.682,0,0,1,1.339-.8.17.17,0,0,1,0,.339h0a1.339,1.339,0,0,0-1.04.647.17.17,0,0,1-.17.076Z",
    transform: "translate(-297.683 -116.741)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    "data-name": "Path 4084",
    d: "M327.127,123.666a.156.156,0,0,1-.138-.085,1.339,1.339,0,0,0-1.013-.692.165.165,0,0,1-.156-.179.17.17,0,0,1,.174-.161,1.691,1.691,0,0,1,1.29.861.174.174,0,0,1-.062.232A.147.147,0,0,1,327.127,123.666Z",
    transform: "translate(-303.587 -115.373)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M381.655,401.3a4.115,4.115,0,0,1-.892.348.084.084,0,0,1-.089-.027.089.089,0,0,1,0-.094c.076-.134.732-1.339,1.174-1.339a.281.281,0,0,1,.245.138.5.5,0,0,1,.067.477A1.08,1.08,0,0,1,381.655,401.3Zm-.723.125c.589-.2.986-.446,1.076-.683a.34.34,0,0,0-.054-.326c-.036-.054-.067-.062-.094-.062-.232.013-.652.6-.928,1.089Z",
    transform: "translate(-333.956 -269.117)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4086",
    "data-name": "Path 4086",
    d: "M380.478,401.168h-.045a.085.085,0,0,1-.071-.049c0-.04-.446-.982-.259-1.482a.446.446,0,0,1,.259-.272h0a.277.277,0,0,1,.344.058c.263.312.027,1.339-.2,1.7A.071.071,0,0,1,380.478,401.168Zm-.085-1.62a.272.272,0,0,0-.134.161,2,2,0,0,0,.188,1.183c.183-.424.286-1.165.129-1.339,0,0-.045-.058-.147,0h0Z",
    transform: "translate(-333.622 -268.641)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4087",
    "data-name": "Path 4087",
    d: "M331.926,407.058a.089.089,0,0,1-.058-.071.076.076,0,0,1,.045-.085c.161-.089,1.589-.839,2.026-.607a.277.277,0,0,1,.143.228h0a.473.473,0,0,1-.152.415c-.388.353-1.415.228-1.995.121Zm1.9-.625a3.5,3.5,0,0,0-1.611.5,2.314,2.314,0,0,0,1.6-.121.308.308,0,0,0,.094-.277.089.089,0,0,0-.053-.089Z",
    transform: "translate(-306.936 -272.474)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4088",
    "data-name": "Path 4088",
    d: "M331.927,406.052H331.9a.076.076,0,0,1-.036-.076,2.408,2.408,0,0,1,.531-1.388.611.611,0,0,1,.469-.152h0c.236,0,.3.134.321.232.071.4-.772,1.191-1.2,1.392A.1.1,0,0,1,331.927,406.052Zm1.017-1.446h-.089a.446.446,0,0,0-.344.116,1.987,1.987,0,0,0-.446,1.111c.446-.272,1.009-.893.968-1.133a.107.107,0,0,0-.1-.094ZM332.864,404.507Z",
    transform: "translate(-306.937 -271.467)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4089",
    "data-name": "Path 4089",
    d: "M287.6,167.927c-1.009,2.079-2.026,4.217-3.012,6.332-.5,1.062-.986,2.12-1.45,3.182s-.928,2.124-1.365,3.186c-.205.531-.446,1.062-.62,1.584l-.286.781a.924.924,0,0,0-.085.214,1.138,1.138,0,0,0,.067.669,4.51,4.51,0,0,0,.567,1.035,20.836,20.836,0,0,0,4.784,4.217l-1.075,2.45a17.97,17.97,0,0,1-1.83-.638,18.19,18.19,0,0,1-1.749-.812,14,14,0,0,1-3.342-2.361,8.14,8.14,0,0,1-1.459-1.892A5.873,5.873,0,0,1,276,183.1a5.6,5.6,0,0,1,.2-1.544l.263-.919c.17-.611.366-1.191.553-1.785.794-2.343,1.687-4.605,2.646-6.832s1.99-4.391,3.124-6.569Z",
    transform: "translate(-275.999 -139.129)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4090",
    "data-name": "Path 4090",
    d: "M285.134,160.15c-3.271,1.026-6.484,12.107-6.484,12.107l7.559,3.307s2.45-5.355,3.856-9.55C291.6,161.44,289.092,158.909,285.134,160.15Z",
    transform: "translate(-277.467 -136.02)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4091",
    "data-name": "Path 4091",
    d: "M294.676,217.84l3.624.357-1.473,4.016s-3.258-.723-3.217-2.5Z",
    transform: "translate(-285.751 -168.14)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4092",
    "data-name": "Path 4092",
    d: "M305.383,220.443l-1.914,3.32-2.709-1.089,1.477-4.034Z",
    transform: "translate(-289.71 -168.583)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4093",
    "data-name": "Path 4093",
    d: "M314.425,127.405a2.468,2.468,0,1,1,2.45-2.468A2.468,2.468,0,0,1,314.425,127.405Zm0-4.712a2.225,2.225,0,1,1,0,.013Z",
    transform: "translate(-295.901 -115.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4094",
    "data-name": "Path 4094",
    d: "M326.468,127.405a2.468,2.468,0,1,1,2.468-2.468A2.468,2.468,0,0,1,326.468,127.405Zm0-4.712a2.214,2.214,0,1,1,0,.013Z",
    transform: "translate(-302.58 -115.328)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinRafiki);
export default __webpack_public_path__ + "static/media/Bitcoin-rafiki.8f871eb8f213e74031061dc5f2435ae4.svg";
export { ForwardRef as ReactComponent };